import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, catchError, throwError, Observable } from 'rxjs';
import { apiUrls } from '../../common/api_urls/api_urls';
import { headers } from '../../common/headers';
import { CommonHttpsService } from '../https/common-https.service';
import { LoaderService } from '../loader/loader.service';
import { session } from '../../common/session/session';
import { CookieService } from 'ngx-cookie-service';
import { ToasterMessageService } from '../topbar-toaster/toaster-message.service';
import { GlobalService } from '../common/global.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AskAiService {


  constructor(
    public loadingService: LoaderService,
    public commonHttpService: CommonHttpsService,
    public cookiesService:CookieService,
    public toastMessage:ToasterMessageService,
    public globalService: GlobalService,
    private http: HttpClient,
  ) { }

  private getUserId(): string {
    const settings = JSON.parse(this.globalService.getUserSettings() || '{}');
    return settings?.userInfo?.id != null ? String(settings.userInfo.id) : '';
  }

  private ragHeadersWithUser(): HttpHeaders {
    return new HttpHeaders({
      [headers.ragHeader]: 'true',
      'X-User-ID': this.getUserId(),
    });
  }

  getHistory(formDataValue: IChatHistory) {
    // this.loadingService.showSpinner();
    const header = new HttpHeaders({ [headers.ragHeader]: 'true' });
    return this.commonHttpService.AddEntity(apiUrls.chatbox.get, formDataValue,
      { headers: header, responseType: 'json' }).pipe(
        tap(() => {
          this.loadingService.stopSpinner();
          this.toastMessage.successMessage("Patient history retrieved successfully.",true);
        }),
        catchError((error) => {
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  sendMessage(formDataValue: ISendMessage) {
    // this.loadingService.showSpinner();
    const header = new HttpHeaders({ [headers.ragHeader]: 'true' });
    return this.commonHttpService.AddEntity(apiUrls.chatbox.send, formDataValue,
      { headers: header, responseType: 'json' }).pipe(
        tap(() => {
          this.loadingService.stopSpinner();
        }),
        catchError((error) => {
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  createSession(threadId: string) {
    return this.commonHttpService.AddEntity(
      apiUrls.chatbox.createSession,
      { thread_id: threadId },
      { headers: this.ragHeadersWithUser(), responseType: 'json' },
      false,
    );
  }

  getChatList(limit: number = 50, offset: number = 0) {
    return this.commonHttpService.GetListwHead(
      apiUrls.chatbox.listChats(limit, offset),
      { headers: this.ragHeadersWithUser() },
    );
  }

  getChatById(threadId: string) {
    return this.commonHttpService.GetByIdwHead(
      apiUrls.chatbox.getChatById(threadId),
      this.ragHeadersWithUser(),
    );
  }

  downloadSource(filePath: string): Observable<Blob> {
    const url = `${environment.commonLookupUrl}/api/${apiUrls.lookUp.download(encodeURIComponent(filePath))}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  askQuestion(payload: IAskRequest) {
    return this.commonHttpService.AddEntity(
      apiUrls.chatbox.ask,
      payload,
      { headers: this.ragHeadersWithUser(), responseType: 'json' },
      false,
    );
  }

  sendMessageStream(payload: ISendMessage) {
    const headersObj: any = {
      'Content-Type': 'application/json',
      [headers.ragHeader]: 'true', // your custom header
    };
    const authToken = this.cookiesService.get(session.authToken);
    if (authToken) headersObj['Authorization'] = `Bearer ${authToken}`;
     return new Observable<string>((observer) => {
    fetch("https://rag-chat-api.carevance.solutions/"+apiUrls.chatbox.send, {
      method: 'POST',
      headers: headersObj,
      body: JSON.stringify(payload)
    }).then(res => {
      if (!res.body) return observer.error('No response body');
      const reader = res.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let accumulated = ''; 
      const read = () => {
          reader.read().then(({ done, value }) => {
            if (done) {
              if (accumulated) observer.next(accumulated); // final chunk
              return observer.complete();
            }
            const chunk = decoder.decode(value, { stream: true });          
            observer.next(chunk);              
            read();
          }).catch(err => observer.error(err));
        };

      read();
    }).catch(err => observer.error(err));
  });
  }
}

export interface IChatHistory {
  caremanager_id: string,
  comid: string,
  email: string,
  page: number,
  limit: number,
}
export interface ISendMessage {
  caremanager_id: string,
  comid: string,
  email: string,
  question: string,
  
}
export interface IThreadMessage {
  id: number;
  thread_id: number | string;
  role: 'assistant' | 'user' | string;
  content: string |undefined |null ;
  created_at: string;
  isStreaming?:boolean;
}

export interface ICreateSessionResponse {
  thread_id: string;
  is_new: boolean;
}

export interface IChatSummary {
  thread_id: string;
  first_question: string;
  last_active: string;
  message_count: number;
}

export interface ISource {
  label: string;
  source_path?: string;
  url?: string;
}

export interface IChatThreadMessage {
  audit_log_id: string;
  question: string;
  answer: string;
  path: string;
  sources: ISource[];
  created_at: string;
}

export interface IChatThreadDetail {
  thread_id: string;
  messages: IChatThreadMessage[];
}

export interface IAskRequest {
  question: string;
  thread_id: string;
}

export interface IAskResponse {
  answer: string;
  path: string;
  sources: ISource[];
  ambiguous_matches: any[];
  thread_id: string;
  clinic_id: string;
  audit_log_id: string;
}
